// extracted by mini-css-extract-plugin
export default {"container":"Service-Details_container__Un0Tc","scrollableContent":"Service-Details_scrollableContent__6yved","paymentStatus":"Service-Details_paymentStatus__CWAlt"};